import axios from "@/api/http";

export function querySuppliers(token) {
  return axios({
    url: '/api/orangevPrivate/querySuppliers',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function queryManagers(token,data) {
  return axios({
    url: '/api/orangevPrivate/queryManagers',
    method: 'post',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function querySales(token,data) {
  return axios({
    url: '/api/orangevPrivate/querySales',
    method: 'post',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function cancelManagerEmployeeLoginInfo(token) {
  return axios({
    url: '/api/orangevPrivate/cancelManagerEmployeeLoginInfo',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

